import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
  head: () => ({
    meta: [
      { title: "Términos y Condiciones — Watts" },
      { name: "description", content: "Términos y Condiciones de uso de la plataforma Watts." },
    ],
  }),
});

function TermsPage() {
  return (
    <div className="min-h-screen bg-[#0f0f0f] text-[#f5f5f5]">
      <div className="mx-auto max-w-2xl px-6 py-8 pb-[max(env(safe-area-inset-bottom),2rem)]">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <Link
            to="/auth"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#1a1a1a] text-[#f5f5f5] hover:bg-[#2a2a2a] transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div>
            <h1 className="font-display text-2xl font-bold tracking-tight">Términos y Condiciones</h1>
            <p className="text-sm text-[#888]">Watts — wattsapp.es</p>
          </div>
        </div>

        <div className="space-y-8 text-sm leading-relaxed text-[#ccc]">
          <div className="rounded-xl bg-[#1a1a1a] p-4 text-xs text-[#888]">
            <p><span className="text-[#f5f5f5] font-medium">Titular:</span> PROAISTUDIO SCP</p>
            <p><span className="text-[#f5f5f5] font-medium">Contacto:</span> proaistudio2@gmail.com</p>
            <p><span className="text-[#f5f5f5] font-medium">Última actualización:</span> 21 de mayo de 2026</p>
          </div>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">1. Objeto</h2>
            <p>Watts es una plataforma digital que permite a usuarios conectar entre sí para organizar salidas de ciclismo de forma autónoma y entre particulares.</p>
            <p className="mt-2">PROAISTUDIO SCP actúa exclusivamente como <strong className="text-[#f5f5f5]">intermediario tecnológico</strong>, sin intervenir, organizar, supervisar ni garantizar las actividades entre usuarios.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">2. Naturaleza del servicio</h2>
            <p>La Plataforma NO es:</p>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Organizador de eventos deportivos</li>
              <li>Club ciclista</li>
              <li>Agencia de viajes</li>
              <li>Empresa de turismo activo</li>
              <li>Guía o monitor deportivo</li>
            </ul>
            <p className="mt-2">Todas las actividades son creadas exclusivamente por usuarios.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">3. Acceso a la plataforma</h2>
            <p>El uso está restringido a <strong className="text-[#f5f5f5]">mayores de 18 años</strong>.</p>
            <p className="mt-2">El usuario declara ser mayor de edad y se compromete a proporcionar información veraz.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">4. Responsabilidad del usuario</h2>
            <p>El usuario reconoce que el ciclismo implica riesgos inherentes.</p>
            <p className="mt-2">Cada usuario participa bajo su <strong className="text-[#f5f5f5]">única y exclusiva responsabilidad</strong>.</p>
            <p className="mt-2">PROAISTUDIO SCP no será responsable de:</p>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Accidentes o lesiones</li>
              <li>Daños personales o materiales</li>
              <li>Conducta de otros usuarios</li>
              <li>Información incorrecta publicada</li>
              <li>Cancelaciones o inasistencia</li>
              <li>Cualquier incidente en actividades entre usuarios</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">5. Ausencia de supervisión</h2>
            <p>La Plataforma no supervisa rutas, usuarios ni actividades.</p>
            <p className="mt-2">No garantiza:</p>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Seguridad de rutas</li>
              <li>Estado del tráfico o clima</li>
              <li>Veracidad de perfiles</li>
              <li>Capacidad física de usuarios</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">6. Relación entre usuarios</h2>
            <p>Las relaciones entre usuarios son privadas y ajenas a PROAISTUDIO SCP.</p>
            <p className="mt-2">La empresa no es parte de ningún acuerdo entre usuarios.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">7. Contenido</h2>
            <p>El usuario es responsable del contenido que publica.</p>
            <p className="mt-2">Concede a PROAISTUDIO SCP una licencia limitada para operar la Plataforma.</p>
            <p className="mt-2">Podemos eliminar contenido que sea ilegal, peligroso o inapropiado.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">8. Moderación</h2>
            <p>Podemos:</p>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Eliminar contenido</li>
              <li>Suspender cuentas</li>
              <li>Bloquear usuarios</li>
              <li>Colaborar con autoridades</li>
            </ul>
            <p className="mt-2">cuando exista riesgo o incumplimiento.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">9. Disponibilidad</h2>
            <p>No garantizamos disponibilidad continua del servicio.</p>
            <p className="mt-2">Puede haber interrupciones técnicas o de mantenimiento.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">10. Suspensión de cuentas</h2>
            <p>Podemos suspender cuentas sin previo aviso en caso de incumplimiento o riesgo.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">11. Propiedad intelectual</h2>
            <p>Todos los elementos de la Plataforma pertenecen a PROAISTUDIO SCP.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">12. Modificaciones</h2>
            <p>Podemos actualizar estos términos en cualquier momento.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">13. Ley aplicable</h2>
            <p>Legislación española.</p>
            <p className="mt-2">Juzgados según normativa de consumidores.</p>
          </section>
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            to="/auth"
            className="inline-flex items-center gap-2 rounded-full bg-[#F5C518] px-6 py-2.5 text-sm font-bold text-black hover:bg-[#e6b800] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al registro
          </Link>
        </div>
      </div>
    </div>
  );
}
